
import React from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';

import Section from 'jsx/elements/section/Section';

import useSharedSidebarProducts  from 'components/hooks/useSharedSidebarProducts';
import useSettingsProducts  from 'components/hooks/useUserSettingsProducts';
import useDefaultUserMenuProducts  from 'components/hooks/useDefaultUserMenuProducts';
import useTranslationApi from 'components/hooks/useCreditinfoTranslation';


import { useAuthContext } from 'components/special/oAuthProvider';
import { useLocale } from 'components/special/LanguageProvider';

import  useRemoveInitApp from 'components/hooks/useRemoveInitApp';
import useToggle from 'components/hooks/useToggle';


import Root from 'components/frame/Root';
import Footer from 'components/frame/Footer';
import Header from 'components/frame/Header';
import MainContent from 'components/frame/MainContent';
import LeftSidebar from 'components/frame/LeftSidebar';



import RightSidebar from 'components/frame/RightSidebar';

import useTopProducts from 'components/hooks/useTopProducts';
import useAdminProducts from 'components/hooks/useAdminProducts';

import {AdminRouter} from './admin/AdminRouter';
import {CalculatorRouter} from './calculator/CalculatorRouter';


import { Demo } from './demo/Demo';
import PageLoading from 'components/messages/PageLoading';
import { ToastProvider } from 'react-toast-notifications'
import { ErrorPage } from './ErrorPage';
import { ClaimRouter } from './claims/ClaimRouter';
import { useHistory } from 'react-router-dom';


export default () => {
  
  const [expanded, toggleExpanded] = useToggle(false);
  const { user, isAuthenticated } = useAuthContext();
  const { t } = useLocale();
  //const [displayLeftMenu, setDisplayLeftMenu] = useState(false);  
  let history = useHistory();

  //console.log("history", history, history.location.pathname.startsWith("/admin"));
  let showRightSidebar = history.location.pathname.startsWith("/admin");

  //console.log("User is authenticated");

  if (!isAuthenticated) {
    useRemoveInitApp();
    return (<div>User is not authenticated</div>); 
  }
  useRemoveInitApp();
  
  

  //Take out translation for start
  let translationsLoaded = useTranslationApi(2002);  

  //console.log("Load init data");
  //Load the data to be used.
  let topProducts = useTopProducts();
  let rightSideBarProducts = useAdminProducts();
  let leftSidebarProducts = useSharedSidebarProducts();
  let settingsProducts = useSettingsProducts();
  let defaultUserMenuProducts = useDefaultUserMenuProducts();

  leftSidebarProducts = leftSidebarProducts.map(product => {
    let res = { ...product };
    if (product.navigationID === 3000) {
      // Innheimtukerfi
      res.children = topProducts.filter(product => typeof product !== 'function');
    }
    return res;
  });  

  //Merger special user menu to.
  settingsProducts = settingsProducts.concat(defaultUserMenuProducts).map(entry => ({
    ...entry,
    label:  t(entry.label),    
    iconCls: entry.iconCls
  }));



  return (
    <PageLoading>    
      <Root sidebarOpen={expanded}>
        <Header
          showMobileNav
          toggleSidebar={toggleExpanded}
          user={user}
          products={topProducts}
          userMenuItems={settingsProducts}
        />
        <MainContent>
          <ToastProvider autoDismissTimeout={3000} transitionDuration={220}>                  
            <section className="section">
              <div className="limit padded" style={{ position: 'relative' }}>
                <Switch>
                  <Route path="/error" component={ErrorPage} />
                  <Route path="/demo" component={Demo}  />
                  <Route path="/claim" component={ClaimRouter} />
                  <Route path="/admin" component={AdminRouter} />
                  <Route path="/calculator" component={CalculatorRouter} />            
                  <Route
                    path="/"
                    render={() => {
                      return <Redirect to={{ pathname: '/admin' }} />;
                    }}
                  />
                </Switch>
              </div>
            </section>          
          </ToastProvider>
        </MainContent>
        <LeftSidebar isExpanded={expanded} toggleExpanded={toggleExpanded} products={leftSidebarProducts} />
        <RightSidebar open={showRightSidebar} navigationList={rightSideBarProducts}/>
        <Footer />
      </Root>
    </PageLoading>
  );
};


